/** API route map: URLS.Controller.PayrollWCRates */
export const PayrollWCRates = {
      Name: 'PayrollWcRates/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      GetBranchNameId: 'getall-branch-ids',
      GetJobWcNameId: 'getall-job-ids',
};
